<div class="loader-container">
  <img src="/assets/base/img/loader.gif" class="loader cw-loader__image" alt="loader"/>
</div>
